import { render, staticRenderFns } from "./CommonWarehouseModal.vue?vue&type=template&id=6058a015&"
import script from "./CommonWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./CommonWarehouseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports